import { useSyncExternalStore } from 'react';

/**
 * KYC progress published by the (globally mounted) KycGate, so other
 * surfaces such as the dashboard's account-opening card show the same
 * numbers without probing the documents a second time.
 */
export interface KycProgressDocument {
  key: string;
  label: string;
  present: boolean;
  preview?: string;
}

export interface KycProgress {
  known: boolean;
  done: number;
  total: number;
  isComplete: boolean;
  documents: KycProgressDocument[];
}

let progress: KycProgress = {
  known: false,
  done: 0,
  total: 0,
  isComplete: false,
  documents: [],
};
let signature = JSON.stringify(progress);
const listeners = new Set<() => void>();

export const publishKycProgress = (next: KycProgress) => {
  const nextSignature = JSON.stringify(next);
  if (nextSignature === signature) return;
  signature = nextSignature;
  progress = next;
  listeners.forEach((listener) => listener());
};

export const useKycProgress = () =>
  useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => progress,
  );

const OPEN_EVENT = 'agb:open-kyc';

/** Opens the verification modal from anywhere in the app. */
export const openKycPrompt = () =>
  window.dispatchEvent(new Event(OPEN_EVENT));

export const onOpenKycPrompt = (handler: () => void) => {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
};
